import axios from 'axios';
import qs from 'qs';
// import { getToken } from '@/utils/auth';
import { assignParams, urlEncode } from '@/until/common';
import crypto from '@/until/encode';
import { xzLocal } from '@/until/common';
import { ElMessageBox, ElMessage } from 'element-plus'
import store from '@/store';


console.log("store0099",store.getters.getNowTheme.lang)
const config = require('./config');

let serverUrlObj = config.testBaseUrl;
console.log("process.env.VUE_APP_ENV",process.env)
if (process.env.VUE_APP_ENV !== 'dev')serverUrlObj = config.masterBaseUrl;

class Server {
  constructor(baseUrl, type) {
    this.baseUrl = baseUrl;
    this.type = type;
    this.instance = axios.create({
      baseURL: this.baseUrl,
      timeout: config.timeout,
      headers: {
        'content-Type': 'application/json',
      },
    });
    this.instance.interceptors.response.use((response) => {
      let responseData = response.data;
      // 服务错误
      if (/error/.test(responseData)) return Promise.reject(new Error({ message: '服务器开小差！！' }));
      // userToken 失效
      if (responseData.Status === 10003) {
        window.location.href = '#/signUp';
      }
      // 当返回数据为加密数据时
      if (typeof responseData !== 'object') {
        const resStr = crypto.decode(responseData);
        responseData = JSON.parse(resStr);
      }
      if (responseData.status != 1) {
          // ElMessage({
          //     message: responseData.message,
          //     type: 'error',
          // });
        // Toast({ title: responseData.message, type: 'error' });
      }
      return responseData;
    }, (error) => {
      if (error && error.response) {
        // eslint-disable-next-line no-param-reassign
        error.message = config.RESPONSE_CODE[error.response.status] || '服务器开小差！！';
      }
      // token 暂时是一直有效，暂时不考虑无效情况
      // token 过期或无效，返回 401 状态码（Unauthorized，客户端错误，验证失败）
      return Promise.reject(error);
    });
    this.instance.interceptors.request.use((confi) => {
      const baseConfig = confi;
      let isEncode = false;
      if (baseConfig.method === 'post') { // post请求
        isEncode = Boolean(baseConfig.data.encode);
        delete baseConfig.data.encode;
        
        Object.assign(baseConfig.headers, {
          'content-Type': 'application/x-www-form-urlencoded',
        });
        if (isEncode) { // 需要加密的数据
          const param = crypto.encode(urlEncode(baseConfig.data));
          baseConfig.data = qs.stringify({ param });
        } else {
          baseConfig.data = qs.stringify(baseConfig.data);
        }
      }
      if (baseConfig.method === 'patch') {
        Object.assign(baseConfig.headers, {
          'content-Type': 'application/x-www-form-urlencoded',
        });
        baseConfig.data = qs.stringify(baseConfig.data);
      }
      return baseConfig;
    }, (err) => {
      console.error('网络异常：', err);
    });
  }

   get = (url, params) => {
    const userToken = xzLocal.get('userToken') ? xzLocal.get('userToken') : null;
    const lang = store.getters.getNowTheme.lang;
     const cpParams = userToken ? assignParams(Object.assign(params,{ userToken,lang})) : assignParams(Object.assign(params,{lang}));
     return this.instance.get(url, { params: cpParams });
   }

   post = (url, params = {}, encode) => {
    const lang = store.getters.getNowTheme.lang;
    const userToken = xzLocal.get('userToken') ? xzLocal.get('userToken') : null;
     const cpParams = userToken
       ? urlEncode(assignParams({ userToken,lang}))
       : urlEncode(assignParams({lang}));
     const data = Object.assign(params, { encode });
     return this.instance.post(`${url}?${cpParams}`, data);
   }

   put=(url, params = {}) => {
    const lang = store.getters.getNowTheme.lang;
    const userToken = xzLocal.get('userToken') ? xzLocal.get('userToken') : null;
    const cpParams = userToken
       ? urlEncode(assignParams({ userToken,lang}))
       : urlEncode(assignParams(lang));
    return this.instance.put(`${url}?${cpParams}`, params);
   }

   delete=(url, params = {}) => {
    const lang = store.getters.getNowTheme.lang;
    const userToken = xzLocal.get('userToken') ? xzLocal.get('userToken') : null;
    const cpParams = userToken
       ? urlEncode(assignParams({ userToken,lang}, params))
       : urlEncode(assignParams(lang));
    return this.instance.delete(`${url}/${params.id}?${cpParams}`);
   }

   patch=(url, params = {}) => {
    const lang = store.getters.getNowTheme.lang;
    const userToken = xzLocal.get('userToken') ? xzLocal.get('userToken') : null;
    const cpParams = userToken
       ? urlEncode(assignParams({ userToken,lang}))
       : urlEncode(assignParams(lang));
    return this.instance.patch(`${url}?${cpParams}`, params);
   }
}

// user 站点
const http = new Server(serverUrlObj.http, 'http');
// 资讯站点
const newshttp = new Server(serverUrlObj.newshttp, 'newshttp');
// 行情站点
const hqhttp = new Server(serverUrlObj.hqhttp, 'hqhttp');
// 支付站点
const payhttp = new Server(serverUrlObj.payhttp, 'payhttp');
// 活动站点
const activityhttp = new Server(serverUrlObj.activityhttp, 'activityhttp');
// 交易站点
const tradehttp = new Server(serverUrlObj.tradehttp, 'tradehttp');
// 模拟交易站点
const stradehttp = new Server(serverUrlObj.stradehttp, 'stradehttp');
// pay支付用后台传递的接口链接
const paymenthttp = new Server('', payhttp);

export default {
  http, newshttp, hqhttp, payhttp, tradehttp, paymenthttp,activityhttp,stradehttp
};
